module.exports = __webpack_public_path__ + "static/media/placeholder-person.6a20c676.png";